<template>
  <b-row>
    <b-col
      lg="6"
      md="12"
      sm="12"
    >
      <b-card>
        <div
          v-if="loading"
          class="loading-state"
        >
          <b-spinner
            variant="light"
            label="Loading..."
          />
        </div>
        <div
          v-else-if="error"
          class="error-state"
        >
          {{ error }}
          <b-button
            size="sm"
            variant="outline-light"
            @click="getWIMData"
          >
            ลองใหม่
          </b-button>
        </div>
        <div
          v-else
          class="ml-3"
        >
          <div class="d-flex justify-content-between align-items-center">
            <b-img
              style="height: 80px;"
              src="@/assets/images/icons/icon-wim/truck.svg"
              alt="truck icon"
            />
            <b-link
              :to="`/wim-table?wid=${this.$route.query.wid}`"
              class="view-more-btn d-flex align-items-center"
            >
              <span class="mr-2 text-white">ดูเพิ่มเติม</span>
              <feather-icon
                icon="InfoIcon"
                size="24"
                class="text-white"
              />
            </b-link>
            <!-- <div>
              <b-button v-b-modal.wimdetail>
                เปิด Modal
                <WIMModal />
              </b-button>
            </div> -->
          </div>
          <h4 class="mt-2 text-white">
            รถเข้าชั่งวันนี้
          </h4>
          <h2 class="mb-75 mt-2 text-white">
            {{ totalVehicles }}
          </h2>
        </div>
      </b-card>
    </b-col>

    <b-col
      lg="6"
      md="12"
      sm="12"
    >
      <b-card class="card-congratulation-medal">
        <div
          v-if="loading"
          class="loading-state"
        >
          <b-spinner
            variant="light"
            label="Loading..."
          />
        </div>
        <div
          v-else-if="error"
          class="error-state"
        >
          {{ error }}
        </div>
        <div
          v-else
          class="ml-3"
        >
          <div>
            <b-img
              style="height: 80px;"
              src="@/assets/images/icons/icon-wim/truckred.svg"
              alt="truck icon"
            />
          </div>
          <h4 class="mt-2 text-white">
            รถน้ำหนักเกิน
          </h4>
          <h3 class="mb-75 mt-2 text-white">
            {{ overWeight }}
          </h3>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BImg,
  BLink,
  BSpinner,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
// import WIMModal from './WIMModal.vue'

export default {
  name: 'WIMDashboard',

  components: {
    BRow,
    BCol,
    BCard,
    BImg,
    BLink,
    BSpinner,
    BButton,
    // WIMModal,
  },

  directives: {
    Ripple,
  },

  data() {
    return {
      loading: false,
      error: null,
      interval: null,
      totalVehicles: '',
      overWeight: '',
    }
  },

  beforeDestroy() {
    this.clearInterval()
  },

  mounted() {
    this.initData()
  },

  methods: {
    initData() {
      this.getWIMData()
      this.startInterval()
    },

    startInterval() {
      this.clearInterval()
      this.interval = setInterval(() => {
        this.getWIMData()
      }, 300000)
    },

    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },

    async getWIMData() {
      if (this.loading) return

      this.loading = true
      this.error = null

      try {
        const response = await axios.post('https://wts.drr.go.th/node-red/get-Data-WIM',
          { wid: this.$route.query.wid },
          {
            headers: {
              'Content-Type': 'application/json',
            },
            timeout: 10000,
          })

        const data = response.data[0]
        this.totalVehicles = data.total_vehicles
        this.overWeight = data.overweight_count
      } catch (error) {
        console.error('Error fetching WIM data:', error)
        this.error = 'ไม่สามารถโหลดข้อมูลได้'
        setTimeout(() => {
          this.getWIMData()
        }, 30000)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

 <style scoped>
 .loading-state,
 .error-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 160px;
  gap: 1rem;
  color: #fff;
 }

 img[alt="truck icon"] {
  height: 80px;
 }

 .view-more-btn {
  padding: 8px 16px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.view-more-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  text-decoration: none;
}

.view-more-btn span {
  font-size: 14px;
  font-weight: 500;
}
 </style>
